import React, { useEffect, useRef } from 'react';
type ContactModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !modalRef.current) return;
      const focusable = modalRef.current.querySelectorAll<HTMLElement>('button:not([disabled]), [href]');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div ref={modalRef} className="contact-modal" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" aria-describedby="contact-modal-subtitle" data-id="element-92">
      <section className="contact-modal__brand" aria-label="SAVIA" data-id="element-93">
        <div className="contact-modal__brand-content" data-id="element-94">
          <p className="contact-modal__quote" data-id="element-95">
            El aroma no se explica.
            <br data-id="element-96" />
            Se habita.
          </p>
          <p className="contact-modal__metadata" data-id="element-97">
            Bogotá, Colombia · Hecho a mano
          </p>
        </div>
      </section>

      <section className="contact-modal__contact-panel" data-id="element-98">
        <button ref={closeButtonRef} type="button" className="contact-modal__close" onClick={onClose} aria-label="Cerrar contacto" data-id="element-99">
          ✕
        </button>

        <div className="contact-modal__content" data-id="element-100">
          <div className="contact-modal__heading" data-id="element-101">
            <h2 id="contact-modal-title" data-id="element-102">Escríbenos</h2>
            <p id="contact-modal-subtitle" className="contact-modal__subtitle" data-id="element-103">
              Respondemos en 24 horas hábiles · Bogotá, Colombia
            </p>
          </div>

          <div className="contact-modal__cards" data-id="element-104">
            <a className="contact-card" href="https://instagram.com/savia.ritualco" target="_blank" rel="noopener noreferrer" data-id="element-105">
              <span className="contact-card__label" data-id="element-106">Instagram</span>
              <span className="contact-card__detail" data-id="element-107">@savia.ritualco</span>
              <span className="contact-card__arrow" aria-hidden="true" data-id="element-108">
                →
              </span>
            </a>

            <a className="contact-card" href="https://wa.me/573213396782" target="_blank" rel="noopener noreferrer" data-id="element-109">
              <span className="contact-card__label" data-id="element-110">WhatsApp</span>
              <span className="contact-card__detail" data-id="element-111">+57 321 339 6782</span>
              <span className="contact-card__arrow" aria-hidden="true" data-id="element-112">
                →
              </span>
            </a>
          </div>
        </div>

        <p className="contact-modal__response-note" data-id="element-113">
          Respondemos en 24 horas hábiles
        </p>
      </section>
    </div>;
}